module.exports = __webpack_public_path__ + "icon-arrow-down-small.svg?f3860d22d6fa010f731fd1158d147de0";